var _path, _circle, _path2, _path3, _g, _rect, _g2, _g3, _path4, _circle2, _path5, _path6, _g4, _rect2, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1273_4374)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0298 30.9979L33.8731 41.7899L29.998 38.3282L40.0298 30.9979Z",
    fill: "url(#paint0_linear_1273_4374)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.4966,
    cy: 30.4975,
    r: 1.8,
    transform: "rotate(-33.7403 40.4966 30.4975)",
    fill: "url(#paint1_linear_1273_4374)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0449 50.1035C38.5415 52.8859 34.9134 54.6367 30.876 54.6367C23.3231 54.6365 17.2003 48.5131 17.2002 40.96C17.2002 37.3795 18.5763 34.1205 20.8281 31.6826L41.0449 50.1035Z",
    fill: "url(#paint2_linear_1273_4374)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1273_4374",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 31,
    width: 25,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0449 50.1035C38.5415 52.8859 34.9134 54.6367 30.876 54.6367C23.3231 54.6365 17.2003 48.5131 17.2002 40.96C17.2002 37.3795 18.5763 34.1205 20.8281 31.6826L41.0449 50.1035Z",
    fill: "url(#paint3_linear_1273_4374)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1273_4374)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1273_4374)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.0008,
    cy: 36.5922,
    rx: 13.2,
    ry: 14.1,
    fill: "white",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1273_4374)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.9,
    cy: 40.4926,
    rx: 3.9,
    ry: 3.6,
    fill: "white"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 66.5665,
    width: 18.6,
    height: 3,
    fill: "url(#paint4_linear_1273_4374)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1273_4374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3 44.9668L33.354 66.5668H17.246L25.3 44.9668Z",
    fill: "url(#paint5_linear_1273_4374)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1273_4374)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.6,
    cy: 49.1664,
    r: 3.6,
    fill: "#3E8BFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.6,
    cy: 49.1664,
    r: 3.15,
    stroke: "#39E4D8",
    strokeWidth: 0.9
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7162 16.3301L69.4551 34.3168L62.9964 28.5474L79.7162 16.3301Z",
    fill: "url(#paint6_linear_1273_4374)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.9152,
    cy: 14.9152,
    r: 3,
    transform: "rotate(-22.3404 80.9152 14.9152)",
    fill: "url(#paint7_linear_1273_4374)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7412 48.0186C77.569 52.6556 71.5227 55.5731 64.7939 55.5732C52.2054 55.5732 42 45.3672 42 32.7783C42.0001 26.8114 44.2934 21.3804 48.0459 17.3174L81.7412 48.0186Z",
    fill: "url(#paint8_linear_1273_4374)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1273_4374",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 17,
    width: 40,
    height: 39
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7412 48.0186C77.5689 52.6559 71.5229 55.5741 64.7939 55.5742C52.2054 55.5742 42 45.3682 42 32.7793C42.0001 26.8121 44.2931 21.3804 48.0459 17.3174L81.7412 48.0186Z",
    fill: "url(#paint9_linear_1273_4374)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1273_4374)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1273_4374)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 70,
    cy: 25.5,
    rx: 22,
    ry: 23.5,
    fill: "white",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1273_4374)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.5,
    cy: 32,
    rx: 6.5,
    ry: 6,
    fill: "white"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 75.4589,
    width: 31,
    height: 5,
    fill: "url(#paint10_linear_1273_4374)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_1273_4374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5 39.459L68.9234 75.459H42.0766L55.5 39.459Z",
    fill: "url(#paint11_linear_1273_4374)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1273_4374)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 46.459,
    r: 6,
    fill: "#3E8BFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 46.459,
    r: 5.25,
    stroke: "#39E4D8",
    strokeWidth: 1.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1273_4374",
    x: 8.80078,
    y: 10.4922,
    width: 50.3999,
    height: 52.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_1273_4374"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1273_4374",
    x: 22,
    y: 30.8926,
    width: 19.7998,
    height: 19.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_1273_4374"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1273_4374",
    x: 17.2461,
    y: 44.9668,
    width: 16.1079,
    height: 25.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.223529 0 0 0 0 0.894118 0 0 0 0 0.847059 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1273_4374"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1273_4374",
    x: 19.6,
    y: 45.5664,
    width: 12.0002,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.231373 0 0 0 0 0.921569 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1273_4374"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1273_4374",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1273_4374",
    x: 28,
    y: -18,
    width: 84,
    height: 87,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_1273_4374"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1273_4374",
    x: 50,
    y: 16,
    width: 33,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_1273_4374"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_1273_4374",
    x: 42.0767,
    y: 39.459,
    width: 26.8467,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.223529 0 0 0 0 0.894118 0 0 0 0 0.847059 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1273_4374"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1273_4374",
    x: 46,
    y: 40.459,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.231373 0 0 0 0 0.921569 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1273_4374"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1273_4374",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1273_4374",
    x1: 28.0489,
    y1: 42.6528,
    x2: 39.0715,
    y2: 31.8294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1273_4374",
    x1: 38.6966,
    y1: 30.4975,
    x2: 42.2966,
    y2: 30.4975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1273_4374",
    x1: 19,
    y1: 51.499,
    x2: 29.2277,
    y2: 31.9357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836538,
    stopColor: "#DD87FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1273_4374",
    x1: 48.4002,
    y1: 31.4928,
    x2: 52.2327,
    y2: 43.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DD0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1273_4374",
    x1: 16,
    y1: 68.0665,
    x2: 34.6,
    y2: 68.0665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CA58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#236EC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1273_4374",
    x1: 36.0467,
    y1: 59.3668,
    x2: 15.0183,
    y2: 59.3668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A4AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D24F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1273_4374",
    x1: 59.7479,
    y1: 35.755,
    x2: 78.119,
    y2: 17.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1273_4374",
    x1: 77.9152,
    y1: 14.9152,
    x2: 83.9152,
    y2: 14.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1273_4374",
    x1: 42,
    y1: 44.501,
    x2: 60.4391,
    y2: 19.1757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836538,
    stopColor: "#DD87FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1273_4374",
    x1: 169.497,
    y1: -10.9998,
    x2: 125.923,
    y2: 91.5481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5723,
    stopColor: "#BE41F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1273_4374",
    x1: 40,
    y1: 77.9589,
    x2: 71,
    y2: 77.9589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CA58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#236EC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1273_4374",
    x1: 73.4111,
    y1: 63.459,
    x2: 38.3639,
    y2: 63.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A4AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D24F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1273_4374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature1.13f12b22a542c52f134d40da2b8f02f1.svg";
export { ForwardRef as ReactComponent };